module.exports = __webpack_public_path__ + "img/N330-2.6c0b10ab.png";